function normalizeSearchValue(value) {
  return String(value ?? '').toLowerCase();
}

function getStudentSearchText(student) {
  return [
    student?.firstName,
    student?.lastName,
    student?.classDescription,
    student?.class,
    student?.className,
  ]
    .filter(Boolean)
    .join(' ');
}

export function matchesStudentSearch(student, searchTerm) {
  const term = normalizeSearchValue(searchTerm).trim();

  if (!term) {
    return true;
  }

  return normalizeSearchValue(getStudentSearchText(student)).includes(term);
}

export function filterStudentsBySearchTerm(items = [], searchTerm = '') {
  return items.filter((item) => matchesStudentSearch(item, searchTerm));
}
